export enum ReportAnalysisOptions {
  ReportShare = 'SOB',
  JATOGlobalSegmentShare = 'SOS',
  VehicleColumnsTypeShare = 'SOV',
  NumericPercentageChange = 'NCH',
}
